import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  /**
   * List of comments by post ID
   */
  comments: {}
}

const getters = {
  comments: state => postId => state.comments[ postId ] || []
}

const findCommentInState = (comment, state) => {
  if (comment.parentId) {
    const index = state.comments[comment.idPost][comment.parentId].children.findIndex((c) => (c.id === comment.id))
    return state.comments[comment.idPost][comment.parentId].children[index]
  } else {
    return state.comments[comment.idPost][comment.id]
  }
}

const mutations = {
  postComments: (state, payload) => {
    Vue.set(state.comments, payload.postId, payload.postComments)
  },
  addPostComments: (state, payload) => {
    if (!payload.postComments.parentId) {
      Vue.set(state.comments[payload.postId], payload.postComments.id, payload.postComments)
    } else {
      state.comments[payload.postId][payload.postComments.parentId].children.push(payload.postComments)
    }
  },
  comments: (state, comments) => {
    state.comments = comments
  },
  updateComment: (state, comment) => {
    let commentInState = findCommentInState(comment, state)
    Vue.set(commentInState, 'comment', comment.comment)
  },
  likeComment: (state, { comment, type, userId }) => {
    // find comment in state
    let commentInState = findCommentInState(comment, state)
    Vue.set(commentInState, 'userLike', { type: type })
    const likeIndex = commentInState.likes.findIndex(like => like.idUser === userId)
    if (likeIndex !== -1) {
      // change like type
      Vue.set(commentInState.likes, likeIndex, { idUser: userId, type: type })
    } else {
      // new like
      commentInState.likes.push({ idUser: userId, type: type })
    }
  },
  unlikeComment: (state, { comment, userId }) => {
    let commentInState = findCommentInState(comment, state)
    commentInState.userLike = undefined
    const likeIndex = commentInState.likes.findIndex(like => like.idUser === userId)
    if (likeIndex !== -1) {
      commentInState.likes.splice(likeIndex, 1)
    }
  }
}

const actions = {
  async getComments ({ commit, state, dispatch }, postId) {
    const result = await axios.get(`${config.getRootApi()}/posts/${postId}/comments`)
    const postComments = result.data
    commit('postComments', { postId: postId, postComments: postComments })
    dispatch('updateCommentsCounter', postId)
  },
  async deleteCommentsFromState ({ commit, state, dispatch }, postId) {
    commit('postComments', { postId: postId, postComments: null })
  },
  async addComment ({ commit, dispatch }, payload) {
    const postId = payload.postId
    const parentId = payload.parentId
    const result = await axios.post(`${config.getRootApi()}/posts/${postId}/comments`, { comment: payload.comment, parentId: parentId })
    if (result.status === 201) {
      commit('addPostComments', { postId: postId, postComments: result.data })
      dispatch('incrementCommentsCounter', postId)
    }
  },
  async editComment({ commit }, payload) {
    const commentId = payload.comment.id
    const result = await axios.post(`${config.getRootApi()}/comments/${commentId}`, payload.comment)
    if (result.status === 200) {
      commit('updateComment', result.data)
    }
    return result
  },
  async softDeleteComment({ dispatch }, payload) {
    const postId = payload.postId
    const commentId = payload.commentId
    const result = await axios.delete(`${config.getRootApi()}/comments/${commentId}`)
    if (result.status === 200) {
      dispatch('getComments', postId)
      return true
    }
    return false
  },
  async softDeleteReportedComment({ dispatch }, payload) {
    const postId = payload.postId
    const commentId = payload.commentId
    return axios.delete(`${config.getRootApi()}/admin/contents/comments/${commentId}`)
      .then(res => {
        if (res.status === 200) {
          dispatch('getComments', postId)
          dispatch('updateReportedCommentsCount', postId)
          return true
        } else {
          return false
        }
      }).catch(() => {
        return false
      })
  },
  async unreportComment ({ dispatch, commit }, payload) {
    const postId = payload.postId
    const commentId = payload.commentId
    return axios.post(`${config.getRootApi()}/admin/contents/comments/${commentId}/unreport`)
      .then(response => {
        if (response.status === 200) {
          dispatch('getComments', postId)
          dispatch('updateReportedCommentsCount', postId)
          commit('decrementCountReportedContent')
          return true
        } else {
          return false
        }
      }).catch(() => {
        return false
      })
  },
  async reportComment({ dispatch }, payload) {
    const commentId = payload.commentId
    const result = await axios.post(`${config.getRootApi()}/comments/${commentId}/report`)
    return result.status === 200
  },
  async likeComment({ commit, state, dispatch, rootState }, payload) {
    const res = await axios.post(`${config.getRootApi()}/comments/${payload.comment.id}/like`, { type: payload.type })
    if (res.status === 200) {
      commit('likeComment', { ...payload, userId: rootState.user.user.id })
    } else {
      console.error(res)
    }
  },
  async unlikeComment({ commit, state, dispatch, rootState }, payload) {
    const res = await axios.post(`${config.getRootApi()}/comments/${payload.comment.id}/unlike`)
    if (res.status === 200) {
      commit('unlikeComment', { ...payload, userId: rootState.user.user.id })
    } else {
      console.error(res)
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
